// extracted by mini-css-extract-plugin
export var section = "logoCarousel-module--section--3T5t-";
export var heading = "logoCarousel-module--heading--cGRkL";
export var text = "logoCarousel-module--text--2T1pw";
export var container = "logoCarousel-module--container--A_4xF";
export var overlay = "logoCarousel-module--overlay--17RQW";
export var logos = "logoCarousel-module--logos--39Qjs";
export var logo = "logoCarousel-module--logo--1f9nC";
export var active = "logoCarousel-module--active--PL5H1";
export var scroll = "logoCarousel-module--scroll--o5Ohh";